import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderFullComponent } from './components/loader-full/loader-full.component';
import { NumberDecimalsLimitDirective } from './directives/number-decimals-limit.directive';
import { FaqComponent } from './components/faq/faq.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DrawerConsultaFacturaComponent } from './components/drawer-consulta-factura/drawer-consulta-factura.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { MantenimientoComponent } from './components/mantenimiento/mantenimiento.component';
import { NzResultModule } from 'ng-zorro-antd/result';

@NgModule({
  declarations: [
    LoaderFullComponent,
    NumberDecimalsLimitDirective,
    FaqComponent,
    DrawerConsultaFacturaComponent,
    MantenimientoComponent
  ],
  imports: [
    CommonModule,
    NzDropDownModule,
    NzCollapseModule,
    NzModalModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    FormsModule,
    NzDrawerModule,
    NzSelectModule,
    NzResultModule
  ],
  exports: [
    LoaderFullComponent,
    NumberDecimalsLimitDirective,
    FaqComponent,
    DrawerConsultaFacturaComponent,
    MantenimientoComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
